export default "__VITE_ASSET__DcNvD9Qg__"